var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWmLogo = function SvgWmLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1860_128182)",
    d: "M15.436 2.592c0-1.421-1.097-2.573-2.45-2.573s-2.45 1.152-2.45 2.573v2.829c0 1.421 1.096 2.574 2.45 2.574 1.353 0 2.45-1.153 2.45-2.574z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_1860_128182)",
    d: "M5.846 6.202c-1.288-.44-2.67.3-3.089 1.65-.418 1.352.287 2.803 1.575 3.243l2.562.874c1.288.439 2.67-.3 3.09-1.651.417-1.352-.288-2.803-1.575-3.242z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_1860_128182)",
    d: "M6.148 16.894c-.796 1.15-.553 2.759.541 3.594s2.628.58 3.424-.57l1.584-2.289c.796-1.15.553-2.759-.542-3.594-1.094-.835-2.627-.58-3.423.57z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_1860_128182)",
    d: "M15.93 19.889c.796 1.15 2.329 1.405 3.424.57s1.337-2.444.54-3.594l-1.583-2.289c-.796-1.15-2.328-1.405-3.423-.57s-1.338 2.444-.542 3.594z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6161FF",
    d: "M13.01 13.86c1.342 0 2.43-1.143 2.43-2.553s-1.088-2.552-2.43-2.552-2.432 1.142-2.432 2.552 1.089 2.553 2.432 2.553M5.077 11.206c1.35 0 2.445-1.15 2.445-2.566 0-1.418-1.094-2.567-2.445-2.567S2.633 7.223 2.633 8.64s1.094 2.566 2.444 2.566M12.986 5.142c1.353 0 2.449-1.151 2.449-2.571S14.339 0 12.986 0s-2.449 1.151-2.449 2.57c0 1.42 1.096 2.572 2.45 2.572M8.129 20.986c1.355 0 2.453-1.153 2.453-2.576 0-1.422-1.098-2.575-2.453-2.575s-2.453 1.153-2.453 2.575 1.098 2.576 2.453 2.576M17.92 20.959c1.352 0 2.448-1.15 2.448-2.57s-1.095-2.57-2.447-2.57-2.448 1.15-2.448 2.57 1.096 2.57 2.448 2.57"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint4_linear_1860_128182)",
    d: "M20.154 6.201c1.288-.439 2.67.3 3.089 1.651.418 1.352-.287 2.803-1.575 3.242l-2.562.874c-1.288.44-2.671-.3-3.09-1.65-.417-1.352.288-2.803 1.575-3.243z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6161FF",
    d: "M20.923 11.206c-1.35 0-2.445-1.15-2.445-2.567s1.095-2.566 2.445-2.566 2.444 1.149 2.444 2.566c0 1.418-1.094 2.567-2.444 2.567"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1860_128182",
    x1: 12.97,
    x2: 13.029,
    y1: -4.924,
    y2: 8.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#6C6CFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1860_128182",
    x1: -1.726,
    x2: 10.566,
    y1: 6.341,
    y2: 10.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#6C6CFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1860_128182",
    x1: 3.935,
    x2: 11.898,
    y1: 24.497,
    y2: 13.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#6C6CFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1860_128182",
    x1: 22.134,
    x2: 14.085,
    y1: 24.448,
    y2: 13.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#6C6CFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1860_128182",
    x1: 27.726,
    x2: 15.434,
    y1: 6.341,
    y2: 10.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#6C6CFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C6CFF",
    stopOpacity: 0.1
  })))));
};
export default SvgWmLogo;